export default __webpack_public_path__ + "static/media/ensalada.0c4a7851.jpg";